/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AdminStockAdjustLocationSkuItem } from './AdminStockAdjustLocationSkuItem';
import {
    AdminStockAdjustLocationSkuItemFromJSON,
    AdminStockAdjustLocationSkuItemFromJSONTyped,
    AdminStockAdjustLocationSkuItemToJSON,
    AdminStockAdjustLocationSkuItemToJSONTyped,
} from './AdminStockAdjustLocationSkuItem';

/**
 * 
 * @export
 * @interface AdminStockAdjustLocationBoxItem
 */
export interface AdminStockAdjustLocationBoxItem {
    /**
     * 箱ID
     * @type {number}
     * @memberof AdminStockAdjustLocationBoxItem
     */
    boxId?: number;
    /**
     * 箱唛编号
     * @type {string}
     * @memberof AdminStockAdjustLocationBoxItem
     */
    markNo?: string;
    /**
     * 长度(厘米)
     * @type {number}
     * @memberof AdminStockAdjustLocationBoxItem
     */
    length?: number;
    /**
     * 宽度(厘米)
     * @type {number}
     * @memberof AdminStockAdjustLocationBoxItem
     */
    width?: number;
    /**
     * 高度(厘米)
     * @type {number}
     * @memberof AdminStockAdjustLocationBoxItem
     */
    height?: number;
    /**
     * 尺寸展示，如 50 x 50 x 40
     * @type {string}
     * @memberof AdminStockAdjustLocationBoxItem
     */
    dimensionSpec?: string;
    /**
     * 计费CBM
     * @type {number}
     * @memberof AdminStockAdjustLocationBoxItem
     */
    cbm?: number;
    /**
     * SKU 数
     * @type {number}
     * @memberof AdminStockAdjustLocationBoxItem
     */
    skuCount?: number;
    /**
     * 库存件数（可用量合计，不含冻结）
     * @type {number}
     * @memberof AdminStockAdjustLocationBoxItem
     */
    inventoryQty?: number;
    /**
     * 冻结件数（冻结量合计）
     * @type {number}
     * @memberof AdminStockAdjustLocationBoxItem
     */
    freezeQty?: number;
    /**
     * 是否空箱：true 是，false 否
     * @type {boolean}
     * @memberof AdminStockAdjustLocationBoxItem
     */
    emptyBox?: boolean;
    /**
     * 货位号
     * @type {string}
     * @memberof AdminStockAdjustLocationBoxItem
     */
    locationNo?: string;
    /**
     * 是否单独保管：0 否 1 是
     * @type {number}
     * @memberof AdminStockAdjustLocationBoxItem
     */
    separateStore?: number;
    /**
     * 
     * @type {Array<AdminStockAdjustLocationSkuItem>}
     * @memberof AdminStockAdjustLocationBoxItem
     */
    skus?: Array<AdminStockAdjustLocationSkuItem>;
}

/**
 * Check if a given object implements the AdminStockAdjustLocationBoxItem interface.
 */
export function instanceOfAdminStockAdjustLocationBoxItem(value: object): value is AdminStockAdjustLocationBoxItem {
    return true;
}

export function AdminStockAdjustLocationBoxItemFromJSON(json: any): AdminStockAdjustLocationBoxItem {
    return AdminStockAdjustLocationBoxItemFromJSONTyped(json, false);
}

export function AdminStockAdjustLocationBoxItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminStockAdjustLocationBoxItem {
    if (json == null) {
        return json;
    }
    return {
        
        'boxId': json['boxId'] == null ? undefined : json['boxId'],
        'markNo': json['markNo'] == null ? undefined : json['markNo'],
        'length': json['length'] == null ? undefined : json['length'],
        'width': json['width'] == null ? undefined : json['width'],
        'height': json['height'] == null ? undefined : json['height'],
        'dimensionSpec': json['dimensionSpec'] == null ? undefined : json['dimensionSpec'],
        'cbm': json['cbm'] == null ? undefined : json['cbm'],
        'skuCount': json['skuCount'] == null ? undefined : json['skuCount'],
        'inventoryQty': json['inventoryQty'] == null ? undefined : json['inventoryQty'],
        'freezeQty': json['freezeQty'] == null ? undefined : json['freezeQty'],
        'emptyBox': json['emptyBox'] == null ? undefined : json['emptyBox'],
        'locationNo': json['locationNo'] == null ? undefined : json['locationNo'],
        'separateStore': json['separateStore'] == null ? undefined : json['separateStore'],
        'skus': json['skus'] == null ? undefined : ((json['skus'] as Array<any>).map(AdminStockAdjustLocationSkuItemFromJSON)),
    };
}

export function AdminStockAdjustLocationBoxItemToJSON(json: any): AdminStockAdjustLocationBoxItem {
    return AdminStockAdjustLocationBoxItemToJSONTyped(json, false);
}

export function AdminStockAdjustLocationBoxItemToJSONTyped(value?: AdminStockAdjustLocationBoxItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'boxId': value['boxId'],
        'markNo': value['markNo'],
        'length': value['length'],
        'width': value['width'],
        'height': value['height'],
        'dimensionSpec': value['dimensionSpec'],
        'cbm': value['cbm'],
        'skuCount': value['skuCount'],
        'inventoryQty': value['inventoryQty'],
        'freezeQty': value['freezeQty'],
        'emptyBox': value['emptyBox'],
        'locationNo': value['locationNo'],
        'separateStore': value['separateStore'],
        'skus': value['skus'] == null ? undefined : ((value['skus'] as Array<any>).map(AdminStockAdjustLocationSkuItemToJSON)),
    };
}

